<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-11-30 16:24:26
 * @LastEditors: voanit
 * @LastEditTime: 2022-12-02 09:27:40
-->
<template>
  <div class="wraper" v-if="noData">
    <img class="image" src="../../../../../assets/images/empty.png" alt="" />
    <div class="des">没有找到商品</div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import $goods from '@/api/modules/goods'
import { AsyncRequest } from '@/utils/request'
import { Toast } from 'mint-ui'
import { pageArgs } from '@/utils'
import { saTrack } from '@/utils/common/shence'
import { toLoginView } from '@/utils/init/env-init'
const action = 'goodsCamp'
export default {
  name: 'goods-camp', // 动态获取训练营的商品链接并跳转到商品页面
  data() {
    return {
      noData: false
    }
  },
  created() {
    // 如果没有登录，先去登录
    // if (!this.hasUser()) {
    //   return
    // }
    this.getCampBuyUrl()
  },
  mixins: [Body],
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取体验营数据
    getWXUserAfter_getData() {
      this.getCampBuyUrl()
    },
    getCampBuyUrl() {
      const { shareCode, userReferrer, fromSrc } = pageArgs.args()
      console.log('args', shareCode)
      saTrack('goods_camp_visit', {
        source: userReferrer ? '微信扫码' : fromSrc ? '积分商城' : '正常访问'
      })
      const self = this
      return AsyncRequest({
        loading: true,
        request: () => $goods.getCampBuyUrl({ shareCode: shareCode }),
        resolve: res => {
          console.log('getCampBuyUrl', res.operateUrl)
          if (res.operateUrl) {
            // location.replace(encodeURIComponent(res.operateUrl))
            location.replace(res.operateUrl)
          }
          if (!res.goodsIdList || res.goodsIdList.length === 0) {
            self.noData = true
            Toast({ message: '没有找到商品' })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wraper {
  display: flex;
  height: 100%;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  .image {
    width: 4rem;
    height: 4rem;
  }
  .des {
    font-size: 0.24rem;
    color: #666666;
    margin-bottom: 2rem;
  }
}
</style>
